import React from 'react'
import { TransactionProcessingDurationDto } from '@/api/Metrics/Types/TransactionProcessingMetricsDto'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { GridColumn as Column, Grid, GridCellProps } from '@progress/kendo-react-grid'

import { formatDuration } from './formatDuration'

interface Props {
  duration?: TransactionProcessingDurationDto
  onClose(): void
}

export const TransactionProcessingMetricsDetailsDialog: React.FC<Props> = ({
  duration,
  onClose,
}) => {
  return (
    <Dialog open={!!duration} onOpenChange={(open) => !open && onClose()}>
      <DialogContent size='lg'>
        <DialogHeader>
          <DialogTitle>
            {duration
              ? `${duration.type.name} / ${duration.paymentProvider.name} — Transition Details`
              : 'Transition Details'}
          </DialogTitle>
        </DialogHeader>
        <Grid data={duration?.transitions ?? []} resizable>
          <Column field='fromCategory.name' title='From' />
          <Column field='toCategory.name' title='To' />
          <Column
            field='medianSeconds'
            title='Median Duration'
            cell={(props: GridCellProps) => <td>{formatDuration(props.dataItem.medianSeconds)}</td>}
          />
          <Column field='sampleSize' title='Sample Size' />
        </Grid>
      </DialogContent>
    </Dialog>
  )
}
